// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__1zngs","icon":"style_icon__3lKHe"};